const fallbackColors = {
  text: '#858dbd',
  placeholder: '#858dbd',
};

const getThemeColor = (variableName: string, fallback: string) => {
  if (typeof window === 'undefined') {
    return fallback;
  }

  const color = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
  return color || fallback;
};

export const getInputOptions = () => {
  const textColor = getThemeColor('--color-form-field-text', fallbackColors.text);
  const placeholderColor = getThemeColor('--color-form-field-placeholder', fallbackColors.placeholder);

  return {
    style: {
      base: {
        color: textColor,
        fontSize: '12px',
        fontWeight: '500',
        lineHeight: '40px',
        fontFamily: '"General Sans", sans-serif',
        '::placeholder': {
          color: placeholderColor,
          fontFamily: '"General Sans", sans-serif',
          fontSize: '12px',
          fontWeight: '500',
        },
      },
      invalid: {
        color: textColor,
      },
    },
  };
};
